import { SHORTCUT_PAGE_INFO_FIELDS } from '@@partner:graphql/shortcuts'
import { VehicleInfo } from '@@partner:types:app'
import { CRUD_Variables, GQL_ID, PageInfo } from '@@partner:types:graphql'
import { gql, useQuery } from '@apollo/client'



export type SingleVehicleQuery = {
  singleVehicle: VehicleInfo
}

export type SingleVehicleVariables = {
  id: GQL_ID
}

export const GQL_QUERY_SINGLE_VEHICLE = gql`
  query singleVehicle($id: ID!) {
    singleVehicle(id: $id) {
      id
      type {
        id
        name
        code
        description
      }
      vehicle_type_id
      license_plate
      vin
      brand
      model
      year
      color
      capacity_kg
      capacity_m3
      temp_min_c
      temp_max_c
      range_km
      average_speed
      is_active
      comment

      boxes {
        id
        name
        number
        vehicle_id
        sort_order
        special_conditions
      }
    }
  }
`

export const useFetchSingleVehicle = (id: GQL_ID) => {
  const { data, loading, error } = useQuery<SingleVehicleQuery, SingleVehicleVariables>(GQL_QUERY_SINGLE_VEHICLE, {
    variables: { id }
  })

  const vehicle = data?.singleVehicle || null

  return { data, loading, error, vehicle }
}